import { render, staticRenderFns } from "./DuwaTrainCompositions.vue?vue&type=template&id=0d0a0fc6"
import script from "./DuwaTrainCompositions.vue?vue&type=script&lang=js"
export * from "./DuwaTrainCompositions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports